import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { GoogleUser } from "./types";
import { TemplateAppType } from "./http";

export interface CurrentUser {
  dashboardAccessToken: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setUserData: (data: any) => void;
  setDashboardAccessToken: (data: string) => void;
  currentUser: GoogleUser | null;
  setCurrentUser: (data: GoogleUser | null) => void;
  email: string;
  setEmail: (email: string) => void;
  appId: string;
  setAppSlug: (id: string) => void;
  appSlug: string;
  setAppId: (id: string) => void;
  appName: string;
  setAppName: (id: string) => void;
  generatedBlog: string;
  setGeneratedBlog: (val: string) => void;
  isOnboardingComplete: boolean;
  setIsOnboardingComplete: (complete: boolean) => void;
  userCreated: boolean;
  setUserCreated: (val: boolean) => void;
  blogImage: string;
  setBlogImage: (val: string) => void;
  selectedApp?: TemplateAppType;
  setSelectedApp: (val?: TemplateAppType) => void;
  appLoginToken: string;
  setAppLoginToken: (token: string) => void;
  isBlogGenerating: boolean;
  setIsBlogGenerating: (val: boolean) => void;
}

const useCurrentUserStore = create<CurrentUser>()(
  devtools(
    persist(
      (set) => ({
        blogImage: "",
        setBlogImage: (data: string) => set(() => ({ blogImage: data })),

        userCreated: false,
        setUserCreated: (data: boolean) => set(() => ({ userCreated: data })),
        generatedBlog: "",
        setGeneratedBlog: (data: string) =>
          set(() => ({ generatedBlog: data })),
        userData: null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setUserData: (data: any) => set(() => ({ userData: data })),
        appName: "",
        setAppName: (id: string) => set(() => ({ appName: id })),
        appId: "",
        setAppId: (id: string) => set(() => ({ appId: id })),
        appSlug: "",
        setAppSlug: (id: string) => set(() => ({ appSlug: id })),
        email: "",
        setEmail: (data: string) => set(() => ({ email: data })),
        dashboardAccessToken: "",
        setDashboardAccessToken: (data: string) =>
          set(() => ({ dashboardAccessToken: data })),
        currentUser: null,
        setCurrentUser: (data: GoogleUser | null) =>
          set(() => ({ currentUser: data })),
        isOnboardingComplete: false,
        setIsOnboardingComplete: (complete: boolean) =>
          set(() => ({ isOnboardingComplete: complete })),
        selectedApp: undefined,
        setSelectedApp: (val?: TemplateAppType) =>
          set(() => ({ selectedApp: val })),
        appLoginToken: "",
        setAppLoginToken: (token: string) =>
          set(() => ({ appLoginToken: token })),
        isBlogGenerating: false,
        setIsBlogGenerating: (val: boolean) =>
          set(() => ({ isBlogGenerating: val })),
      }),
      { name: "current-user-store" }
    )
  )
);

export default useCurrentUserStore;
